export default "__VITE_ASSET__201530ae__"